import { render, staticRenderFns } from "./trouble-keeps-crashing.vue?vue&type=template&id=5ede938f"
import script from "./trouble-keeps-crashing.vue?vue&type=script&lang=js"
export * from "./trouble-keeps-crashing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports